/**
 * @generated SignedSource<<d553f972a98ad7b3065614acaf998bda>>
 * @relayHash dbfe00fb39056eb3a0f24ae626006e70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CreateCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null | undefined;
  containerId: string;
  parentCommentId?: string | null | undefined;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type CommentRepliesCreateGeneralReplyMutation$variables = {
  cloudId: string;
  includeReactions: boolean;
  input: CreateCommentInput;
  pageId: string;
};
export type CommentRepliesCreateGeneralReplyMutation$data = {
  readonly createFooterComment: {
    readonly author: {
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null | undefined;
      readonly webui: string | null | undefined;
    };
    readonly location: {
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineMarkerRef?: string | null | undefined;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineText?: string | null | undefined;
      readonly type: string;
    };
    readonly parentId: string | null | undefined;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null | undefined>;
    } | null | undefined;
    readonly version: {
      readonly by: {
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly number: number | null | undefined;
      readonly when: string | null | undefined;
    };
  } | null | undefined;
};
export type CommentRepliesCreateGeneralReplyMutation = {
  response: CommentRepliesCreateGeneralReplyMutation$data;
  variables: CommentRepliesCreateGeneralReplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v11 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v12 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v13 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v10/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v15 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "type"
},
v17 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v18 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v19 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v20 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v23 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v24 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v25 = {
  "condition": "includeReactions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "pageId"
        }
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            }
          ]
        }
      ]
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "when"
},
v27 = {
  "kind": "ScalarField",
  "name": "number"
},
v28 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentRepliesCreateGeneralReplyMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "createFooterComment",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              },
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentRepliesCreateGeneralReplyMutation",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "createFooterComment",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v16/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v26/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dbfe00fb39056eb3a0f24ae626006e70",
    "id": "37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c",
    "metadata": {},
    "name": "CommentRepliesCreateGeneralReplyMutation",
    "operationKind": "mutation",
    "text": "mutation CommentRepliesCreateGeneralReplyMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactions:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},version{by{__typename,displayName},when,number}}}"
  }
};
})();

(node as any).hash = "42751e8cecbdf3c515d561bda37d1e47";

export default node;
